/**
 * Big Waster API
 * This is a Big Waster API.
 *
 * OpenAPI spec version: 1.0
 * Contact: terry.wong@futureimpactlab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The UtilHttpErrorBody model module.
 * @module model/UtilHttpErrorBody
 * @version 1.0
 */
class UtilHttpErrorBody {
    /**
     * Constructs a new <code>UtilHttpErrorBody</code>.
     * @alias module:model/UtilHttpErrorBody
     */
    constructor() { 
        
        UtilHttpErrorBody.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>UtilHttpErrorBody</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/UtilHttpErrorBody} obj Optional instance to populate.
     * @return {module:model/UtilHttpErrorBody} The populated <code>UtilHttpErrorBody</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new UtilHttpErrorBody();

            if (data.hasOwnProperty('error')) {
                obj['error'] = ApiClient.convertToType(data['error'], 'String');
            }
        }
        return obj;
    }


}

/**
 * @member {String} error
 */
UtilHttpErrorBody.prototype['error'] = undefined;






export default UtilHttpErrorBody;

